// LinkDropdown.jsx
import { Dropdown } from 'react-bootstrap';

function LinkDropdown({
  buttonContent,
  buttonClassName,
  menuClassName,
  items = [],      // [{ label, href, onClick, ... }]
  variant = 'primary',
  id,
  ...dropdownProps // остальные пропсы пробрасываем в <Dropdown>
}) {
  return (
    <Dropdown {...dropdownProps}>
      <Dropdown.Toggle variant={variant} id={id} className={buttonClassName}>
        {buttonContent}
      </Dropdown.Toggle>

      <Dropdown.Menu className={`link-dropdown-menu ${menuClassName}`.trim()}>
        {items.map((item, index) => (
          <Dropdown.Item
            key={item.key ?? item.href ?? index}
            href={item.href}
            onClick={item.onClick}
            {...item.props} // любые доп. пропсы для конкретного пункта
          >
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default LinkDropdown;